/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
// eslint-disable-next-line import/no-extraneous-dependencies
import React, { useContext } from 'react';
import SelectBoxTree from '../../../base/SelectBoxTree/SelectBoxTree';
import SelectBox from '../../../base/SelectBox/SelectBox';
import QuestionContext from '../../Context/QuestionContext';
import classes from './CheckboxQuestion.scss';

interface ICheckboxQuestion {
  defaultAnswers: Array<number>;
  checkBoxChangeParent: (addedOptionId?: number, removedOptionId?: number) => void;
  checkBoxChangeChild: (addedOptionId?: number, removedOptionId?: number) => void;
  flexDirection: 'column' | 'row';
  onFocus?: () => void;
  onBlur?: () => void;
}

const CheckboxQuestion: React.FC<ICheckboxQuestion> = ({ defaultAnswers, checkBoxChangeParent, checkBoxChangeChild, flexDirection, onFocus, onBlur }) => {
  const { question } = useContext(QuestionContext);

  const handleChangeParent = (checked: boolean, domId: string) => {
    if (checked) {
      checkBoxChangeParent(+domId, undefined);
    } else {
      checkBoxChangeParent(undefined, +domId);
    }
  };

  const handleChangeChild = (checked: boolean, domId: string) => {
    if (checked) {
      checkBoxChangeChild(+domId, undefined);
    } else {
      checkBoxChangeChild(undefined, +domId);
    }
  };

  return (
    <>
      <h4 className={`mb4 ${classes.title}`}>{question.name}</h4>
      <div
        className={flexDirection === 'column' ? `${classes.fcol}` : undefined}
        onKeyPress={() => {}}
        role="button"
        tabIndex={0}
        onFocus={() => {
          if (onFocus) onFocus();
        }}
        onBlur={() => {
          if (onBlur) onBlur();
        }}
      >
        {question.answers.map((option) => {
          const subOptions = option.subAnswers;
          if (subOptions)
            return (
              <SelectBoxTree
                key={option.id}
                domId={option.id.toString()}
                text={option.name}
                subOptions={subOptions}
                checkeds={defaultAnswers.filter((answer) => answer === option.id || subOptions.findIndex((subOption) => subOption.id === answer) !== -1)}
                onChangeParent={handleChangeParent}
                onChangeChild={handleChangeChild}
              />
            );

          return <SelectBox key={option.id} domId={option.id.toString()} text={option.name} checked={defaultAnswers.includes(option.id)} onChange={handleChangeChild} />;
        })}
      </div>
    </>
  );
};
export default CheckboxQuestion;
